/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import { SchoolType } from 'types';

const prefix = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

const classOptions = Array(12)
  .fill(null)
  .map((item, index) => ({
    label: `Lớp ${index + 1}`,
    value: index + 1,
  }))
  .concat([
    {
      label: 'Mầm non',
      value: 0,
    },
  ]);

export const classOptionsBySchoolTypeId = (schoolTypeId?: number) => {
  let arr;
  switch (schoolTypeId) {
    case 0:
      arr = [0];
      break;
    case 1:
      arr = [1, 2, 3, 4, 5];
      break;
    case 2:
      arr = [6, 7, 8, 9];
      break;
    case 3:
      arr = [10, 11, 12];
      break;
    default:
      arr = Array(12).concat([0]);
  }
  return classOptions.filter((option) => arr.includes(option.value));
};

const classOptionsBySchoolType = (schoolTypeId: number, isUseOptionAll = false) => {
  const arr = schoolTypeId === 0 ? [0] : schoolTypeId === 1 ? [1, 2, 3, 4, 5] : schoolTypeId === 2 ? [6, 7, 8, 9] : schoolTypeId === 3 ? [10, 11, 12] : [];

  const options = (isUseOptionAll ? [{ value: '', label: 'Tất cả' }] : []).concat(
    arr.map((item) =>
      item === 0
        ? {
            label: 'Mầm non',
            value: 'Mầm non',
          }
        : {
            label: `Lớp ${item}`,
            value: `Lớp ${item}`,
          },
    ),
  );
  return options;
};

const unitOptions = [
  { value: 'Unit Starter', label: 'Unit Starter' },
  { label: 'Unit 1', value: 'Unit 1' },
  { label: 'Unit 2', value: 'Unit 2' },
  { label: 'Unit 3', value: 'Unit 3' },
  { label: 'Unit 4', value: 'Unit 4' },
  { label: 'Unit 5', value: 'Unit 5' },
  { label: 'Unit 6', value: 'Unit 6' },
  { label: 'Unit 7', value: 'Unit 7' },
  { label: 'Unit 8', value: 'Unit 8' },
  { label: 'Unit 9', value: 'Unit 9' },
  { label: 'Unit 10', value: 'Unit 10' },
  { label: 'Unit 11', value: 'Unit 11' },
  { label: 'Unit 12', value: 'Unit 12' },
  { label: 'End of Year', value: 'End of Year' },
];

const unitOptionsByClass = (className: string, isUseOptionAll = false) => {
  const number = className.replace('Lớp ', '');
  let options: any[] = [];
  if (['1', '2'].includes(number)) {
    const lastOption = unitOptions[unitOptions.length - 1];
    options = unitOptions.slice(0, 7).concat([lastOption]);
  } else if (['6', '7', '8', '9', '10', '11', '12'].includes(number)) {
    options = unitOptions.slice(0, 9);
  } else {
    options = unitOptions;
  }
  if (isUseOptionAll) {
    options = [{ value: '', label: 'Tất cả' }, ...options];
  }
  return options;
};

// Dùng phần loại bài câu hỏi theo cấp học
const schoolTypeCodeOption: {
  label: string;
  value: SchoolType;
  schoolTypeId: 1 | 2 | 3;
}[] = [
  {
    label: 'Tiểu học',
    value: 'TH',
    schoolTypeId: 1,
  },
  {
    label: 'THCS',
    value: 'THCS',
    schoolTypeId: 2,
  },
  {
    label: 'THPT',
    value: 'THPT',
    schoolTypeId: 3,
  },
];

// Dùng phần loại bài câu hỏi theo cấp học
const questionGradeOption = [
  {
    label: 'Nhận biết',
    value: 'ELEMENTARY',
  },
  {
    label: 'Thông hiểu',
    value: 'PREINTERMEDIATE',
  },
  {
    label: 'Vận dụng',
    value: 'INTERMEDIATE',
  },
];

const assignmentTypeOption = [
  { label: 'Luyện tập', value: 'PRACTICE' }, // HS được làm bài nhiều lần, và đáp án sẽ hiển thị sau khi nộp bài;
  { label: 'Kiểm tra', value: 'EXAM' }, // HS chỉ được làm bài 1 lần, phải có thời gian mở đề, đóng đề (Để HS cùng bắt đầu 1 lúc)
];

const skillOptions = [
  {
    label: 'Vocabulary & Structures',
    value: 'V',
  },
  {
    label: 'Writing',
    value: 'W',
  },
  {
    label: 'Listening',
    value: 'L',
  },
  {
    label: 'Reading',
    value: 'R',
  },
  {
    label: 'Speaking',
    value: 'S',
  },
  {
    label: 'Phonetics',
    value: 'P',
  },
];

const skillOptionsBySchoolType = (schoolTypeId: number, isUseOptionAll = false) => {
  let skillCodes: string[] = [];
  let options: any[] = [];
  switch (schoolTypeId) {
    case 1:
      skillCodes = ['L', 'R', 'W'];
      break;
    case 2:
      skillCodes = ['P', 'V', 'R', 'W', 'S'];
      break;
    case 3:
      skillCodes = ['P', 'V', 'R', 'W'];
      break;

    default:
      break;
  }
  options = skillOptions.filter((option) => skillCodes.includes(option.value));
  if (isUseOptionAll) {
    options = [{ value: '', label: 'Tất cả' }, ...options];
  }
  return options;
};

export { classOptions, unitOptions, prefix, schoolTypeCodeOption, questionGradeOption, assignmentTypeOption, classOptionsBySchoolType, unitOptionsByClass, skillOptions, skillOptionsBySchoolType };
